import pages from '../../../config/i18n.pages'

const setList = payload => {
  let page
  const { routeName, param, data } = payload

  const baseUrl = process.env.BASE_URL
  const alternate = []

  page = routeName.split('___')[0]

  const locale = routeName.split('___')[1]
  switch (page) {
    case 'locale':
      page = 'index'
      break

    default:
      break
  }

  const defaultUrl = pages[`${page}`]['en'] ? `en${pages[`${page}`]['en']}` : `pt-br${pages[`${page}`]['pt-br']}`

  const alternateDefault = {
    hid: 'alt-default',
    rel: 'alternate',
    href: `${baseUrl}/${defaultUrl}`,
    hreflang: 'x-default',
  }

  if (param) {
    let code, exist

    exist = false

    code = 'fr'
    if (data[code].length > 0) {
      exist = true
      alternateDefault.href = `${baseUrl}/${`${code}${pages[`${page}`][code]}`.replace('/:slug', '')}/${data[code]}`
    }
    code = 'es'
    if (data[code].length > 0) {
      exist = true
      alternateDefault.href = `${baseUrl}/${`${code}${pages[`${page}`][code]}`.replace('/:slug', '')}/${data[code]}`
    }
    code = 'pt-br'
    if (data[code].length > 0) {
      exist = true
      alternateDefault.href = `${baseUrl}/${`${code}${pages[`${page}`][code]}`.replace('/:slug', '')}/${data[code]}`
    }
    code = 'en'
    if (data[code].length > 0) {
      exist = true
      alternateDefault.href = `${baseUrl}/${`${code}${pages[`${page}`][code]}`.replace('/:slug', '')}/${data[code]}`
    }

    exist ? alternate.push(alternateDefault) : null
  } else alternate.push(alternateDefault)

  const allowedLocales = ['pt-br', 'es', 'co', 'mx', 'la', 'en']

  const pagesVariants = Object.keys(pages[`${page}`]).filter(v => allowedLocales.includes(v))

  pagesVariants.map(variant => {
    if (variant) {
      const slug = param && data[variant].length > 0 ? `/${data[variant]}` : ''
      const href = `${baseUrl}/${variant}${pages[page][variant].replace('/:slug', '')}${slug}`
      const alternateObj = {
        hid: `alt-${variant}`,
        rel: 'alternate',
        href,
        hreflang: variant,
      }

      if (!param || (param && data[variant].length > 0)) {
        alternate.push(alternateObj)
      }
    }

    return true
  })

  return alternate
}

export default {
  setList,
}
